import React from "react";
import { withApollo } from "react-apollo";

class CategoryFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: "",
      name: "",
      status: "",
      errors: []
    };

    this.submitForm = this.submitForm.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  componentDidMount() {
    var filterData = this.props.filterData;
    this.setState({
      id: filterData && filterData.id ? filterData.id : "",
      name: filterData && filterData.name ? filterData.name : "",
      status: filterData && filterData.status ? filterData.status : "",
    });
  }

  resetForm() {
    this.setState({ ...this.initialState, errors: [] });
    this.props.filterAction();
    this.props.listData({}, false);
  }

  submitForm() {
    //Use below variables to Update DB via GraphQL after all validations pass
    const { id, name, status, } = this.state;

    this.setState({ errors: [] });
    let data = {
      id: parseInt(id),
      name: name,
      status: status,
    };
    this.props.filterAction();
    this.props.listData(data, true);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.filterData) {
      var filterData = nextProps.filterData;
      this.setState({
        id: filterData && filterData.id ? filterData.id : "",
        name: filterData && filterData.name ? filterData.name : "",
        status: filterData && filterData.status ? filterData.status : "",
      });
    }
  }

  render() {
    const { showFilter } = this.props;
    const { id, name, status, } = this.state;

    return (
      <div
        className="filter-popup"
        style={
          showFilter
            ? {
                display: "block"
              }
            : { display: "none" }
        }
      >
        <form className="m-t-15">
          {/* <div className="form-group">
            <label>Project ID</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Project ID to Search"
              maxLength="6"
              value={id}
              onChange={e => {
                this.setState({ id: e.target.value });
              }}
              onKeyUp={(e)=> {
                if (e.which == 13 || e.keyCode == 13) {
                  e.preventDefault();
                  this.submitForm();
                  return false;
                }
                return true;
              }}
            />
          </div> */}
          <div className="form-group">
            <label>Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Name to Search"
              value={name}
              onChange={e => {
                this.setState({ name: e.target.value });
              }}
              onKeyUp={(e)=> {
                if (e.which == 13 || e.keyCode == 13) {
                  e.preventDefault();
                  this.submitForm();
                  return false;
                }
                return true;
              }}
            />
          </div>
          <div className="form-group">
            <label>Status</label>
            <select className="form-control" value={status} onChange={e => {
                this.setState({ status: parseInt(e.target.value) });
              }}>
                <option value="" disabled>Select</option>
                <option value={1}>Active</option>
                <option value={2}>Suspended</option>
                <option value={3}>Terminated</option>
                <option value={4}>Pending for Activation</option>
            </select>
          </div>

          <div className="row">
            <div className="col-md-6 text-center">
              <button
                type="button"
                className="btn btn-light btn-block"
                onClick={this.resetForm}
              >
                Clear
              </button>
            </div>
            <div className="col-md-6 text-center">
              <button
                type="button"
                className="btn btn-danger btn-block"
                onClick={this.submitForm}
              >
                Apply
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default withApollo(CategoryFilter);